import { AbiRegistry, Address, SmartContract } from '@multiversx/sdk-core/out';
import { proxyContractAddress } from 'src/config.js';
import json from 'src/contracts/tada-proxy.json';

const abi = AbiRegistry.create(json);

export const smartContract = new SmartContract({
    address: new Address(proxyContractAddress),
    abi,
});

const getStakingTypes = (abi) => {
    return abi.types.StakingType.variants.reduce((acc, variant) => {
        acc[variant.name] = variant.discriminant;
        return acc;
    }, {});
};

export const stakingTypes = getStakingTypes(json);
export const stakingTypesEnum = abi.getEnum("StakingType");